var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: ["site", _vm.navReady && "site--contained"],
      style: _vm.brandingVars,
      attrs: { id: "app", mode: _vm.activeMode }
    },
    [
      _vm.navReady
        ? _c("VueUiChat", {
            attrs: {
              displayOnActiveFeatureSwitches: [
                _vm.FEATURE_SWITCHES.AI_POWERED_INTERFACE
              ]
            }
          })
        : _vm._e(),
      _vm.navReady
        ? _c("VueUiHeader", { attrs: { reponsibleForUserInfo: false } })
        : _vm._e(),
      _vm.navReady ? _c("hr", { staticClass: "horizontal-div" }) : _vm._e(),
      _vm.navReady
        ? _c("VueUiMenu", { attrs: { reponsibleForUserInfo: false } })
        : _vm._e(),
      _vm.navReady
        ? _c("VueUiTitle", {
            attrs: { pageVersion: 2, setPageVersion: true },
            on: {
              versionChange: _vm.onVersionChange,
              versionChangeStart: _vm.onVersionChangeStart
            }
          })
        : _vm._e(),
      _vm.displayConcurrentUsers
        ? _c("VueConcurrentUsers", {
            ref: "concurrentUsersRef",
            staticClass: "active-users--concurrent-layout"
          })
        : _vm._e(),
      _vm.appReady
        ? _c("VueUiAlerts", {
            attrs: { showingNavigation: _vm.showNavigation }
          })
        : _vm._e(),
      _c("VueUiWarning"),
      _vm.appPageLoading
        ? _c(
            "OverlayBackdrop",
            { attrs: { fullPage: true, zIndex: 12000 } },
            [
              _c("Loader", {
                staticClass: "site__app-loading",
                attrs: { variant: "squareExploder" }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "main",
        { class: ["site__content", _vm.hasActionRibbon && "has-action-bar"] },
        [
          _vm.showModeToggle ? _c("ModeToggle") : _vm._e(),
          _c("ErrorNotification"),
          _vm.showRouterView ? _c("router-view") : _vm._e()
        ],
        1
      ),
      _vm.messagePageWithCid
        ? _c("iframe", {
            ref: "messageFrame",
            staticStyle: {
              visibility: "hidden",
              position: "absolute",
              top: "-9999px",
              left: "-9999px"
            },
            attrs: { src: _vm.messagePageWithCid, height: "0", width: "0" }
          })
        : _vm._e(),
      _c("AccessPageViewer"),
      _c("DesktopOptimized"),
      _c("div", { attrs: { id: "footermarker" } }),
      _c(
        "div",
        {
          class: [
            _vm.showNavigation && "site__toast-container",
            !_vm.showNavigation && "site__toast-container-iframe"
          ]
        },
        [
          _c("portal-target", {
            staticClass: "toasts",
            attrs: { name: "toast", multiple: "", tag: "ul" }
          })
        ],
        1
      ),
      _c("portal-target", { attrs: { name: "popover" } }),
      _c("portal-target", { staticClass: "vue-chat", attrs: { name: "chat" } }),
      _c("portal-target", { attrs: { name: "modal", multiple: "" } }),
      _c("PrintQueueMultipleIframe")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }